import About from "./components/About";
import Projects from "./components/Projects";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Skill from "./components/Skill";
import Contact from "./components/Contact";
import Home from "./components/Home";
import "./cutom-css.css";

function App() {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Skill />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
